import {
    trigger,
    state,
    style,
    transition,
    animate,
    AnimationTriggerMetadata,
  } from '@angular/animations';
  
  // Fade In Out Animation
  export const fadeInOut: AnimationTriggerMetadata = trigger('fadeInOut', [
    transition(':enter', [ // alias for 'void => *'
      style({ opacity: 0 }),
      animate('300ms ease-in', style({ opacity: 1 }))
    ]),
    transition(':leave', [ // alias for '* => void'
      animate('300ms ease-out', style({ opacity: 0 }))
    ])
  ]);
  
  // Slide In/Out Animation
  export const slideInOut: AnimationTriggerMetadata = trigger('slideInOut', [
    transition(':enter', [
      style({ transform: 'translateY(-100%)' }),
      animate('300ms ease-in', style({ transform: 'translateY(0%)' }))
    ]),
    transition(':leave', [
      animate('300ms ease-out', style({ transform: 'translateY(-100%)' }))
    ])
  ]);
  
  // Rotate Animation
  export const rotate: AnimationTriggerMetadata = trigger('rotate', [
    state('default', style({ transform: 'rotate(0)' })),
    state('rotated', style({ transform: 'rotate(180deg)' })),
    transition('default <=> rotated', animate('300ms ease-in-out'))
  ]);
  